
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/amazon-sqs",
      function () {
        return require("private-next-pages/destinations/amazon-sqs.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/amazon-sqs"])
      });
    }
  